import React from "react";
import { PHILANTHROPY, COMMUNITY } from "../../mock";
import { Heart, HandHeart, Users, Home } from "lucide-react";
import { SectionTitle } from "./About";

export default function Philanthropy() {
  const icons = [Home, Users, HandHeart];
  return (
    <section id="service" className="scroll-smooth-section py-24">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <SectionTitle
          kicker="Service"
          title="Twenty-eight organizations. One mission."
          subtitle="Patron, Trustee or Chairman of 28+ charitable bodies — from Red Cross India to ANACI to the Sree Narayana Trust."
        />

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {COMMUNITY.map((c, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="bg-cream rounded-2xl p-7 lift border border-stone-200/60">
                <div className="w-12 h-12 rounded-full bg-emerald-deep flex items-center justify-center mb-4">
                  <Icon className="w-6 h-6 text-gold" />
                </div>
                <div className="font-display text-xl text-emerald-deep">{c.title}</div>
                <p className="text-stone-700 mt-2 leading-relaxed">{c.text}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-12 bg-ivory rounded-3xl p-8 md:p-10 border border-stone-200/60 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <Heart className="w-5 h-5 text-gold" />
            <span className="text-xs uppercase tracking-widest text-emerald-deep">Trustee · Patron · Chairman</span>
          </div>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
            {PHILANTHROPY.map((p, i) => (
              <div key={i} className="flex items-start gap-3 py-2 border-b border-stone-100">
                <span className="text-gold mt-1">❧</span>
                <span className="text-stone-700 text-sm">{p}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
